/* LegalScreen — privacy, terms, support */
import { TopBar, IconButton } from '@koridor/design-system';
import { Capacitor } from '@capacitor/core';
import React from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

const CONTENT: Record<string, { title: string; body: React.ReactNode }> = {
  privacy: {
    title: 'Политика конфиденциальности',
    body: (
      <>
        <p>Коридор (quoridorapp.ru) обрабатывает данные, необходимые для игры и аккаунта: никнейм, email, рейтинг, история партий, настройки и технические токены сессии.</p>
        <p>Мы не продаём персональные данные третьим лицам. Данные хранятся на серверах в РФ/ЕС в зависимости от хостинга и используются для аутентификации, матчмейкинга, рейтинга и push-уведомлений (при согласии).</p>
        <p>Вы можете запросить удаление аккаунта в настройках приложения. После удаления профиль анонимизируется, история партий сохраняется без привязки к личным данным.</p>
        <p>Обновлено: июль 2026.</p>
      </>
    ),
  },
  terms: {
    title: 'Условия использования',
    body: (
      <>
        <p>Используя Коридор, вы соглашаетесь играть честно, не злоупотреблять API и не мешать другим игрокам.</p>
        <p>Сервис предоставляется «как есть». Мы можем изменять правила, рейтинговую систему и функции с уведомлением в приложении.</p>
        <p>Запрещены читы, боты, оскорбления и попытки взлома. Нарушители могут быть заблокированы.</p>
        <p>Обновлено: июль 2026.</p>
      </>
    ),
  },
  support: {
    title: 'Поддержка',
    body: (
      <>
        <p>По вопросам аккаунта, багов и предложений:</p>
        <p><a href="mailto:support@quoridorapp.ru">support@quoridorapp.ru</a></p>
        <p>Укажите никнейм, email и краткое описание проблемы — так мы быстрее поможем.</p>
      </>
    ),
  },
};

export function LegalScreen() {
  const navigate = useNavigate();
  const { page } = useParams<{ page: string }>();
  const doc = CONTENT[page ?? ''] ?? CONTENT.privacy;

  const isNative = Capacitor.isNativePlatform();

  return (
    <div className={isNative ? 'native-fill' : undefined} style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: isNative ? undefined : '100vh',
      height: isNative ? '100%' : undefined,
      background: 'var(--bg-app)',
      paddingTop: isNative ? 'env(safe-area-inset-top)' : undefined,
      paddingBottom: isNative ? 'env(safe-area-inset-bottom)' : undefined,
    }}>
      <TopBar
        leading={<IconButton label="Назад" variant="ghost" onClick={() => navigate(-1)}>‹</IconButton>}
        title={doc.title}
        style={{ background: 'transparent', borderBottom: '1px solid var(--border-subtle)' }}
      />
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '20px var(--gutter) 40px',
        fontSize: 15,
        lineHeight: 1.55,
        color: 'var(--text-primary)',
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>{doc.body}</div>
        <div style={{ marginTop: 32, display: 'flex', flexWrap: 'wrap', gap: 16, fontSize: 13 }}>
          <Link to="/legal/privacy">Конфиденциальность</Link>
          <Link to="/legal/terms">Условия</Link>
          <Link to="/legal/support">Поддержка</Link>
        </div>
      </div>
    </div>
  );
}
